export default class Organization {
  constructor(
    private organizationId: number = null,
    private name: string = ''
  ){} 
}